export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/JavaScriptWorker.worker.6c29a2e3.js");
}
